import HomePage from './pages/public/HomePage';
import TermsPage from './pages/public/TermsPage';
import NotFoundPage from './pages/public/NotFoundPage';
import {NavLink, Route, Routes} from "react-router";
import {Button, Nav, Navbar, NavItem, Stack} from "react-bootstrap";
import {useUserSession} from "./utils/UserSession";
import {useMemo} from "react";
import {ObjectUtil} from "zavadil-ts-common";
import AdminSection from "./pages/admin/AdminSection";
import {useRestClient} from "./client/SpmRestClient";

export default function Main() {
	const restClient = useRestClient();
	const session = useUserSession();
	const isLoggedIn = useMemo(() => ObjectUtil.notEmpty(session.user), [session]);

	return (
		<div className="pb-4">
			<Navbar bg="dark" variant="dark" expand="md" className="px-2">
				<Navbar.Brand className="p-1">
					<NavLink to="">SPM</NavLink>
				</Navbar.Brand>
				{
					isLoggedIn && <>
						<Navbar.Toggle aria-controls="main-navbar" className="me-auto"/>
						<Navbar.Collapse id="main-navbar">
							<Nav className="m-auto gap-2">
								<NavItem>
									<NavLink to="/admin/nodes">
										Otázky
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/check">
										Kontrola
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/contacts">
										Kontakty
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/contacts-import/sluzby-pro-migranty">
										Import
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/scraper">
										Scraper
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/users">
										Uživatelé
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink to="/admin/profile">
										Profil
									</NavLink>
								</NavItem>
							</Nav>
						</Navbar.Collapse>
					</>
				}
				{
					isLoggedIn ? <div>
							<Button variant="link" onClick={() => restClient.logOut()}>
								Odhlásit
							</Button>
						</div> :
						<Stack direction="horizontal" className="ms-auto">
							<NavLink to="/admin/nodes">
								Vstup pro správce
							</NavLink>
						</Stack>
				}
			</Navbar>
			<Routes>
				<Route path="/" element={<HomePage/>}/>
				<Route path="/podminky" element={<TermsPage/>}/>
				<Route path="/admin/*" element={<AdminSection/>}/>
				<Route path="*" element={<NotFoundPage/>}/>
			</Routes>
		</div>
	);
}
